import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35;

import { isTrue } from "@dp/common";
import { action, computed, makeObservable, observable, runInAction } from "mobx";
import { ORDER_TYPE } from ".";
import BrandRules from "../../utils/BrandRules";
import { decodeIsAlcohol, decodeIsAdvanceOrderingProduct, findMenuItemAvailibity, formatPriceOC } from "../../utils/common";
import { persist } from "mobx-persist";
var MenuListModel = (_dec = persist("map"), (_class = /*#__PURE__*/function () {
  //React.Ref<typeof Box> Not an observable...just a ref Map
  function MenuListModel(platformUtil) {
    var _this = this;

    _classCallCheck(this, MenuListModel);

    _initializerDefineProperty(this, "_currentCategoryCode", _descriptor, this);

    _initializerDefineProperty(this, "_nextCategoryCode", _descriptor2, this);

    _initializerDefineProperty(this, "_categoryRefs", _descriptor3, this);

    _initializerDefineProperty(this, "_menuDetail", _descriptor4, this);

    _initializerDefineProperty(this, "_actualPickupTime", _descriptor5, this);

    _initializerDefineProperty(this, "_unavailableItems", _descriptor6, this);

    _initializerDefineProperty(this, "_dayPartInfo", _descriptor7, this);

    _initializerDefineProperty(this, "_favoritesData", _descriptor8, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor9, this);

    _initializerDefineProperty(this, "_isListView", _descriptor10, this);

    _initializerDefineProperty(this, "_recommendationsList", _descriptor11, this);

    _initializerDefineProperty(this, "_checkoutSmartRecommendationsList", _descriptor12, this);

    _initializerDefineProperty(this, "_resturantId", _descriptor13, this);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor14, this);

    _initializerDefineProperty(this, "_isLoggedIn", _descriptor15, this);

    _initializerDefineProperty(this, "_quickAddItem", _descriptor16, this);

    _initializerDefineProperty(this, "_showQuickAddMenuCustomizationModal", _descriptor17, this);

    _initializerDefineProperty(this, "_frequentlyOrderedItems", _descriptor18, this);

    _initializerDefineProperty(this, "_showCategoryHeroImages", _descriptor19, this);

    _initializerDefineProperty(this, "_currentPickupTime", _descriptor20, this);

    _initializerDefineProperty(this, "_orderTypeValue", _descriptor21, this);

    _initializerDefineProperty(this, "_route", _descriptor22, this);

    _initializerDefineProperty(this, "_isRecommendationAlreadyViewed", _descriptor23, this);

    _initializerDefineProperty(this, "_itemSelectedForAdding", _descriptor24, this);

    _initializerDefineProperty(this, "_showRestStatusFlag", _descriptor25, this);

    _initializerDefineProperty(this, "_editingLocation", _descriptor26, this);

    _initializerDefineProperty(this, "_happyHourDescription", _descriptor27, this);

    _initializerDefineProperty(this, "_restaurantHourList", _descriptor28, this);

    _initializerDefineProperty(this, "_currentAddToCartLoadingItemID", _descriptor29, this);

    _initializerDefineProperty(this, "_lunchSlots", _descriptor30, this);

    _initializerDefineProperty(this, "_currentTime", _descriptor31, this);

    _initializerDefineProperty(this, "_showMenuCategoryModal", _descriptor32, this);

    _initializerDefineProperty(this, "_categories", _descriptor33, this);

    _initializerDefineProperty(this, "_tempSelectionMenuIdsMap", _descriptor34, this);

    _defineProperty(this, "platformUtil", void 0);

    _defineProperty(this, "setCategoryRef", function (code, ref) {
      runInAction(function () {
        _this._categoryRefs[code] = ref;
      });
    });

    _defineProperty(this, "clearCategoryRefs", function () {
      runInAction(function () {
        _this._categoryRefs = {};
      });
    });

    _initializerDefineProperty(this, "_pdfMenuUrl", _descriptor35, this);

    this.platformUtil = platformUtil;
    makeObservable(this);
  }

  _createClass(MenuListModel, [{
    key: "setItemSelectedForAdding",
    value: function setItemSelectedForAdding(item) {
      this._itemSelectedForAdding = item;
    }
  }, {
    key: "formatPrice",
    value: function formatPrice(price) {
      var _BrandRules, _this$_appAttributes;

      var pricingFormat = (_BrandRules = new BrandRules((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : _this$_appAttributes.currentConceptCode)) === null || _BrandRules === void 0 ? void 0 : _BrandRules.pricingFormat(); // taken in reference from the method formatPriceOC in orderConfirmationModel
      // if (
      //   this._appAttributes?.currentConceptCode?.toLowerCase() === "cg" ||
      //   this._appAttributes?.currentConceptCode?.toLowerCase() === "cb"
      // ) {
      //   return `${price.toFixed(2)}`;
      // }

      switch (pricingFormat) {
        case "$xx":
          return "$".concat(price.toFixed(0));

        case "$xx.xx":
          return "$".concat(price.toFixed(2));

        case "xx":
          return "".concat(price.toFixed(0));

        case "xx.xx":
          return "".concat(price.toFixed(2));

        case "s52":
          return "".concat(Number(price.toFixed(2)));

        default:
          return "$".concat(price.toFixed(2));
      }
    }
  }, {
    key: "showFormattedPriceForOrderHistory",
    value: function showFormattedPriceForOrderHistory(price) {
      var _BrandRules2, _this$_appAttributes2;

      return formatPriceOC(Number(price), (_BrandRules2 = new BrandRules((_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : _this$_appAttributes2.currentConceptCode)) === null || _BrandRules2 === void 0 ? void 0 : _BrandRules2.pricingFormat());
    }
  }, {
    key: "showFormattedPrice",
    value: function showFormattedPrice(num) {
      var finalResult;
      if (!num) return;

      if (typeof num === "string") {
        if (num.length <= 0) return "";
        var res = num.replace(/[^\d.]/g, "");
        var b = num.replace(/[\d.]/g, "").replace("$", "");
        finalResult = b + this.formatPrice(Number(res));
      } else {
        finalResult = this.formatPrice(num);
      }

      return finalResult.toString();
    }
  }, {
    key: "setRoute",
    value: function setRoute(route) {
      this._route = route;
    }
  }, {
    key: "setIsRecommendationAlreadyViewed",
    value: function setIsRecommendationAlreadyViewed(bool) {
      var _this$platformUtil,
          _this2 = this;

      (_this$platformUtil = this.platformUtil) === null || _this$platformUtil === void 0 ? void 0 : _this$platformUtil.saveInLocalStorage("isRecommendationAlreadyViewed", String(bool));
      runInAction(function () {
        _this2._isRecommendationAlreadyViewed = bool;
      });
    }
  }, {
    key: "getIsRecommendationAlreadyViewed",
    value: function () {
      var _getIsRecommendationAlreadyViewed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$platformUtil2,
            _this3 = this;

        var _isRecommendationAlreadyViewed;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (_this$platformUtil2 = this.platformUtil) === null || _this$platformUtil2 === void 0 ? void 0 : _this$platformUtil2.getFromLocalStorage("isRecommendationAlreadyViewed").then(JSON.parse);

              case 2:
                _isRecommendationAlreadyViewed = _context.sent;
                runInAction(function () {
                  if (typeof _isRecommendationAlreadyViewed === "boolean") {
                    _this3._isRecommendationAlreadyViewed = _isRecommendationAlreadyViewed;
                  } else {
                    _this3._isRecommendationAlreadyViewed = false;
                  }
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getIsRecommendationAlreadyViewed() {
        return _getIsRecommendationAlreadyViewed.apply(this, arguments);
      }

      return getIsRecommendationAlreadyViewed;
    }()
  }, {
    key: "setLunchSlotsAndCurrentTime",
    value: function setLunchSlotsAndCurrentTime(slots, currentTime) {
      this._lunchSlots = slots;
      this._currentTime = currentTime;
    }
  }, {
    key: "setPickupTimeData",
    value: function setPickupTimeData(data) {
      var _this4 = this;

      runInAction(function () {
        _this4._currentPickupTime = data;
      });
    }
  }, {
    key: "setFrequentlyOrderItemData",
    value: function setFrequentlyOrderItemData(item) {
      var _this5 = this;

      runInAction(function () {
        _this5._frequentlyOrderedItems = item;
      });
    }
  }, {
    key: "toggleShowQuickAddMenuCustomizationModal",
    value: function toggleShowQuickAddMenuCustomizationModal(show) {
      var _this6 = this;

      runInAction(function () {
        _this6._showQuickAddMenuCustomizationModal = show;
      });
    }
  }, {
    key: "setQuickAddItemData",
    value: function setQuickAddItemData(quickAdItem) {
      var _this7 = this;

      runInAction(function () {
        _this7._quickAddItem = quickAdItem;
      });
    }
  }, {
    key: "setReturantId",
    value: function setReturantId(_id) {
      var _this8 = this;

      runInAction(function () {
        _this8._resturantId = _id;
      });
    }
  }, {
    key: "setAppAttributesData",
    value: function setAppAttributesData(_appAttributes) {
      var _this9 = this;

      runInAction(function () {
        _this9._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "setSessionDetails",
    value: function setSessionDetails(_sessionDetails) {
      var _this10 = this;

      runInAction(function () {
        _this10._sessionDetails = _sessionDetails;
      });
    }
    /*public setStyleCode(_styleCode: string) {
      runInAction(() => {
        this._styleCode = _styleCode;
      });
    }*/

  }, {
    key: "setUserLoggedInData",
    value: function setUserLoggedInData(isloggedin) {
      this._isLoggedIn = isloggedin;
    }
  }, {
    key: "setRecommendationData",
    value: function setRecommendationData(_recomentations) {
      var _this11 = this;

      runInAction(function () {
        _this11._recommendationsList = _recomentations;
      });
    }
  }, {
    key: "setCheckoutSmartRecommendationList",
    value: function setCheckoutSmartRecommendationList(_recomentations) {
      var _this12 = this;

      runInAction(function () {
        _this12._checkoutSmartRecommendationsList = _recomentations;
      });
    }
  }, {
    key: "setFavorites",
    value: function setFavorites(_favorites) {
      var _this13 = this;

      runInAction(function () {
        _this13._favoritesData = _favorites;
      });
    }
  }, {
    key: "setFavorite",
    value: function setFavorite(_fav) {
      var _this14 = this;

      runInAction(function () {
        _this14._favoritesData.push(_fav);
      });
    }
  }, {
    key: "_getCategories",
    value: function _getCategories(_menuDetail) {
      var _menuDetail$subCatego,
          _this15 = this;

      var categories = [];
      _menuDetail === null || _menuDetail === void 0 ? void 0 : (_menuDetail$subCatego = _menuDetail.subCategories) === null || _menuDetail$subCatego === void 0 ? void 0 : _menuDetail$subCatego.forEach(function (cat) {
        categories.push(_this15.decodeCategory(cat));
      });
      return categories;
    }
  }, {
    key: "setMenuDetailData",
    value: function setMenuDetailData(_menuDetail) {
      var _this16 = this;

      var categories = this._getCategories(_menuDetail);

      runInAction(function () {
        _this16._categories = categories;
        _this16._menuDetail = _menuDetail;
      });
    }
  }, {
    key: "updateMenuItemsAvailabity",
    value: function updateMenuItemsAvailabity() {
      var _this17 = this;

      var categories = this._getCategories(this._menuDetail);

      runInAction(function () {
        _this17._categories = categories;
      });
    }
  }, {
    key: "setUnavailableItemsData",
    value: function setUnavailableItemsData(_unavailableItems) {
      var _this18 = this;

      runInAction(function () {
        _this18._unavailableItems = _unavailableItems;
      });
    }
  }, {
    key: "setCurrentAddToCartLoadingItemID",
    value: function setCurrentAddToCartLoadingItemID(id) {
      this._currentAddToCartLoadingItemID = id;
    }
  }, {
    key: "setDayPartInfoData",
    value: function setDayPartInfoData(_dayPartInfo) {
      var _this19 = this;

      runInAction(function () {
        _this19._dayPartInfo = _dayPartInfo;
      });
    }
  }, {
    key: "setActualPickupTimeData",
    value: function setActualPickupTimeData(_actualPickupTime) {
      var _this20 = this;

      runInAction(function () {
        _this20._actualPickupTime = _actualPickupTime;
      });
    }
  }, {
    key: "setAttributes",
    value: function setAttributes(_appAttributes) {
      this._appAttributes = _appAttributes;
    }
  }, {
    key: "setCategories",
    value: function setCategories(categories) {
      var _this21 = this;

      runInAction(function () {
        _this21._categories = categories;
      });
    }
  }, {
    key: "setOrderTypeValue",
    value: function setOrderTypeValue(_orderType) {
      this._orderTypeValue = _orderType;
    }
  }, {
    key: "decodeRecommendations",

    /*private isMenuUnavailable(id: string) {
      return this._unavailableItems?.products86ed[id] !== null;
    }*/
    value: function decodeRecommendations(recomendation, menulist) {
      return menulist.find(function (_menu) {
        return _menu.id === recomendation.id;
      });
    }
  }, {
    key: "decodeFrequentlyOrderedItems",
    value: function decodeFrequentlyOrderedItems(frequentlyOrderedItemId, menulist) {
      return menulist.find(function (_menu) {
        return _menu.id === frequentlyOrderedItemId;
      });
    }
  }, {
    key: "decodeIndicators",
    value: function decodeIndicators(indicators) {
      var _this$_appAttributes3;

      var indicatorIconBaseUrl = (_this$_appAttributes3 = this._appAttributes) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3.configs.mediaRoot_marketing_indicator_https;
      var topIndicators;
      var bottomIndicators = [];

      if ((indicators === null || indicators === void 0 ? void 0 : indicators.length) === 0) {
        return {
          topIndicators: topIndicators,
          bottomIndicators: bottomIndicators
        };
      }

      try {
        var _this$_appAttributes4, _this$_appAttributes5, _indicators$map, _indicators$map$filte, _indicators$map2, _indicators$map2$filt;

        var excludedIndecators = JSON.parse((_this$_appAttributes4 = this._appAttributes) === null || _this$_appAttributes4 === void 0 ? void 0 : (_this$_appAttributes5 = _this$_appAttributes4.configs) === null || _this$_appAttributes5 === void 0 ? void 0 : _this$_appAttributes5.topIndicators);
        bottomIndicators = indicators === null || indicators === void 0 ? void 0 : (_indicators$map = indicators.map(function (ind) {
          var _excludedIndecators$i;

          var indicatorCode = ind === null || ind === void 0 ? void 0 : ind.code;
          var isTopIndicator = excludedIndecators === null || excludedIndecators === void 0 ? void 0 : (_excludedIndecators$i = excludedIndecators.indicatorList) === null || _excludedIndecators$i === void 0 ? void 0 : _excludedIndecators$i.find(function (item) {
            return item.indicatorCode === indicatorCode;
          });

          if (isTopIndicator) {
            return undefined;
          }

          if (indicatorCode.includes("Sodium Philly")) {
            return undefined;
          }

          var indicator = ind;

          if (!indicator) {
            return undefined;
          }

          return {
            iconUrl: "".concat(indicatorIconBaseUrl, "/").concat(indicator.imageUrl),
            tooltipText: indicator.legendText,
            indicatorCode: indicator.code
          };
        })) === null || _indicators$map === void 0 ? void 0 : (_indicators$map$filte = _indicators$map.filter(function (i) {
          return i !== undefined;
        })) === null || _indicators$map$filte === void 0 ? void 0 : _indicators$map$filte.slice(0, 3);
        topIndicators = indicators === null || indicators === void 0 ? void 0 : (_indicators$map2 = indicators.map(function (ind) {
          var _excludedIndecators$i2, _excludedIndecators$i3;

          var indicatorCode = ind === null || ind === void 0 ? void 0 : ind.code;
          var isTopIndicator = excludedIndecators === null || excludedIndecators === void 0 ? void 0 : (_excludedIndecators$i2 = excludedIndecators.indicatorList) === null || _excludedIndecators$i2 === void 0 ? void 0 : _excludedIndecators$i2.find(function (item) {
            return item.indicatorCode === indicatorCode;
          });

          if (!isTopIndicator) {
            return undefined;
          }

          var indicator = ind;

          if (!indicator) {
            return undefined;
          }

          var indicatorText = excludedIndecators === null || excludedIndecators === void 0 ? void 0 : (_excludedIndecators$i3 = excludedIndecators.indicatorList) === null || _excludedIndecators$i3 === void 0 ? void 0 : _excludedIndecators$i3.find(function (ind) {
            return ind.indicatorCode === indicator.code;
          }).indicatorText;
          return {
            iconUrl: "".concat(indicatorIconBaseUrl, "/").concat(indicator.imageUrl),
            tooltipText: indicatorText.toUpperCase(),
            indicatorCode: indicator.code
          };
        })) === null || _indicators$map2 === void 0 ? void 0 : (_indicators$map2$filt = _indicators$map2.filter(function (i) {
          return i !== undefined;
        })) === null || _indicators$map2$filt === void 0 ? void 0 : _indicators$map2$filt.slice(0, 3)[0];
      } catch (e) {
        console.log("error", e);
      }

      return {
        topIndicators: topIndicators,
        bottomIndicators: bottomIndicators
      };
    }
  }, {
    key: "decodeSodiumIndicator",
    value: function decodeSodiumIndicator(indicators) {
      var _this$_appAttributes6, _this$_appAttributes7;

      var indicatorsMap = (_this$_appAttributes6 = this._appAttributes) === null || _this$_appAttributes6 === void 0 ? void 0 : _this$_appAttributes6.indicatorsMap;
      var indicatorIconBaseUrl = (_this$_appAttributes7 = this._appAttributes) === null || _this$_appAttributes7 === void 0 ? void 0 : _this$_appAttributes7.configs.mediaRoot_marketing_indicator_https;

      if (!indicatorsMap) {
        return null;
      }

      var transformedIndicator = indicators === null || indicators === void 0 ? void 0 : indicators.find(function (ind) {
        var _ind$code, _ind$code$includes;

        return ind === null || ind === void 0 ? void 0 : (_ind$code = ind.code) === null || _ind$code === void 0 ? void 0 : (_ind$code$includes = _ind$code.includes) === null || _ind$code$includes === void 0 ? void 0 : _ind$code$includes.call(_ind$code, "Sodium Philly");
      });
      var indicator = indicatorsMap === null || indicatorsMap === void 0 ? void 0 : indicatorsMap[transformedIndicator === null || transformedIndicator === void 0 ? void 0 : transformedIndicator.code];

      if (!indicator) {
        return undefined;
      }

      return {
        iconUrl: "".concat(indicatorIconBaseUrl, "/").concat(indicator.imageUrl),
        tooltipText: indicator.longDescription,
        indicatorCode: indicator.indicatorCode
      };
    }
  }, {
    key: "decodeFavorites",
    value: function decodeFavorites(productId) {
      var _this$_favoritesData;

      return (_this$_favoritesData = this._favoritesData) === null || _this$_favoritesData === void 0 ? void 0 : _this$_favoritesData.some(function (fav) {
        return fav.productId === productId;
      });
    }
  }, {
    key: "decodeSuggested",
    value: function decodeSuggested(productId) {
      if (this.enableMenuItemsSmartRec) {
        var _this$_recommendation;

        return (_this$_recommendation = this._recommendationsList) === null || _this$_recommendation === void 0 ? void 0 : _this$_recommendation.some(function (p) {
          return p.id === productId;
        });
      }

      return false;
    }
  }, {
    key: "isItemSuggested",
    value: function isItemSuggested(productId) {
      var _this$decodeSuggested;

      return this === null || this === void 0 ? void 0 : (_this$decodeSuggested = this.decodeSuggested) === null || _this$decodeSuggested === void 0 ? void 0 : _this$decodeSuggested.call(this, productId);
    }
  }, {
    key: "getImageUrl",
    value: function getImageUrl(url) {
      if (url === null) {
        var _this$_appAttributes8, _this$_appAttributes9;

        if (((_this$_appAttributes8 = this._appAttributes) === null || _this$_appAttributes8 === void 0 ? void 0 : (_this$_appAttributes9 = _this$_appAttributes8.concept) === null || _this$_appAttributes9 === void 0 ? void 0 : _this$_appAttributes9.conceptCode) === "LH") {
          var _this$_appAttributes10, _this$_appAttributes11;

          return (_this$_appAttributes10 = this._appAttributes) === null || _this$_appAttributes10 === void 0 ? void 0 : (_this$_appAttributes11 = _this$_appAttributes10.configs) === null || _this$_appAttributes11 === void 0 ? void 0 : _this$_appAttributes11.mediaRoot_menulistingimage_url;
        } else {
          var _this$_appAttributes12, _this$_appAttributes13;

          return (_this$_appAttributes12 = this._appAttributes) === null || _this$_appAttributes12 === void 0 ? void 0 : (_this$_appAttributes13 = _this$_appAttributes12.configs) === null || _this$_appAttributes13 === void 0 ? void 0 : _this$_appAttributes13.mediaRoot_stoneimage_url;
        }
      }

      return url;
    }
  }, {
    key: "decodeIsNew",
    value: function decodeIsNew(indicators) {
      return indicators === null || indicators === void 0 ? void 0 : indicators.some(function (ind) {
        return (ind === null || ind === void 0 ? void 0 : ind.code) === "NI";
      });
    }
  }, {
    key: "filterItemsByOrderType",
    value: function filterItemsByOrderType(items) {
      if (this.orderType !== ORDER_TYPE.ORDER_AHEAD) {
        return items === null || items === void 0 ? void 0 : items.filter(function (item) {
          return (item === null || item === void 0 ? void 0 : item.applicableOrderTypes) !== "DINEIN_ONLY" || (item === null || item === void 0 ? void 0 : item.applicableOrderTypes) === null;
        });
      }

      return items === null || items === void 0 ? void 0 : items.filter(function (item) {
        return ((item === null || item === void 0 ? void 0 : item.applicableOrderTypes) !== "TOGO_ONLY" || (item === null || item === void 0 ? void 0 : item.applicableOrderTypes) === null) && (item === null || item === void 0 ? void 0 : item.isBulkItem) !== true;
      });
    }
  }, {
    key: "_decodeIsBeverageItem",
    value: function _decodeIsBeverageItem(isAlcohol, isBeverageItem) {
      if (this.isDineinOrder && isBeverageItem) {
        var _this$_sessionDetails, _this$_sessionDetails2;

        if (!!((_this$_sessionDetails = this._sessionDetails) !== null && _this$_sessionDetails !== void 0 && (_this$_sessionDetails2 = _this$_sessionDetails.restaurantDetails) !== null && _this$_sessionDetails2 !== void 0 && _this$_sessionDetails2.enableNABOrderAhead) && !isAlcohol) {
          // enabled Add CTA
          return false;
        } // Show Order With Server


        return true;
      }

      return false;
    }
  }, {
    key: "decodeMenuItem",
    value: function decodeMenuItem(menu) {
      var _menu$advanceOrdering, _menu$advanceOrdering2, _this$getImageUrl;

      var price = menu === null || menu === void 0 ? void 0 : menu.price;

      var _isAlcohol = menu === null || menu === void 0 ? void 0 : menu.isAlcohol;

      var alcoholSubClassification = menu === null || menu === void 0 ? void 0 : menu.alcoholSubClassification;

      var _this$_decodeIsAlcoho = this._decodeIsAlcohol(_isAlcohol, alcoholSubClassification),
          isAlcohol = _this$_decodeIsAlcoho.isAlcohol,
          toolTipMessage = _this$_decodeIsAlcoho.toolTipMessage;

      var _this$checkMenuItemAv = this.checkMenuItemAvailibility(menu === null || menu === void 0 ? void 0 : menu.id, menu === null || menu === void 0 ? void 0 : menu.dayPartInfo, menu === null || menu === void 0 ? void 0 : menu.advanceOrdering),
          isUnavailable = _this$checkMenuItemAv.isUnavailable,
          unAvailableMessage = _this$checkMenuItemAv.unAvailableMessage;

      var isAdvanceOrderingProduct = this._decodeIsAdvanceOrderingProduct(isUnavailable, unAvailableMessage);

      var productAvailableStartDate = menu === null || menu === void 0 ? void 0 : (_menu$advanceOrdering = menu.advanceOrdering) === null || _menu$advanceOrdering === void 0 ? void 0 : (_menu$advanceOrdering2 = _menu$advanceOrdering[0]) === null || _menu$advanceOrdering2 === void 0 ? void 0 : _menu$advanceOrdering2.startDate;
      return {
        id: menu.id,
        name: menu.name,
        code: menu.id,
        nutritionalFDAMessage: this.hideCalorieOnMenuList ? null : menu.nutritionalFDAMessage,
        isAlcohol: isAlcohol,
        toolTipMessage: toolTipMessage,
        price: price,
        calorieCount: this.hideCalorieOnMenuList ? null : menu.calories && menu.calories + "",
        imageUrl: (_this$getImageUrl = this.getImageUrl(menu.imageURL)) === null || _this$getImageUrl === void 0 ? void 0 : _this$getImageUrl.trim(),
        imgAltText: menu.imgAltText,
        indicators: this.decodeIndicators(menu.specialInfoIcons),
        isFavourite: this.decodeFavorites(menu.id),
        //TODO mashup
        isUnavailable: isAlcohol && this.isTogoDeliveryOrder ? true : isUnavailable,
        unAvailableMessage: unAvailableMessage,
        isSuggested: this.decodeSuggested(menu.id),
        isNew: this.decodeIsNew(menu.specialInfoIcons),
        isDineInOnly: menu.isDineInOnly,
        isBeverageItem: this._decodeIsBeverageItem(isAlcohol, menu.isBeverageItem),
        isComplex: menu.isComplex,
        slug: menu.slug,
        breadCrumbSlug: menu.breadCrumbSlug,
        isPriceHidden: this.isPriceHidden,
        isSimpleProduct: menu.isSimpleProduct,
        sodiumIndicator: this.decodeSodiumIndicator(menu.specialInfoIcons),
        displayPrice: this.decodeIfDisplayPrice(menu === null || menu === void 0 ? void 0 : menu.price) ? "" : menu.formattedPrice,
        fields: menu === null || menu === void 0 ? void 0 : menu.fields,
        applicableOrderTypes: menu === null || menu === void 0 ? void 0 : menu.applicableOrderTypes,
        isBulkItem: menu === null || menu === void 0 ? void 0 : menu.isBulkItem,
        displayCalorie: menu === null || menu === void 0 ? void 0 : menu.displayCalorie,
        alcoholSubClassification: alcoholSubClassification,
        description: menu === null || menu === void 0 ? void 0 : menu.description,
        longDescription: menu === null || menu === void 0 ? void 0 : menu.longDescription,
        isAdvanceOrderingProduct: isAdvanceOrderingProduct,
        productAvailableStartDate: productAvailableStartDate,
        winePairingIds: menu === null || menu === void 0 ? void 0 : menu.winePairingIds
      };
    }
  }, {
    key: "decodeIfDisplayPrice",
    value: function decodeIfDisplayPrice(price) {
      return this.isPriceHidden || Number(price).toFixed(2) === "0.00";
    }
  }, {
    key: "_decodeIsAlcohol",
    value: function _decodeIsAlcohol(isAlcohol, alcoholSubClassification) {
      var _this$_sessionDetails3;

      return decodeIsAlcohol(isAlcohol, (_this$_sessionDetails3 = this._sessionDetails) === null || _this$_sessionDetails3 === void 0 ? void 0 : _this$_sessionDetails3.restaurantDetails, alcoholSubClassification, this.orderType);
    }
  }, {
    key: "checkMenuItemAvailibility",
    value: function checkMenuItemAvailibility(id, dayPartInfo, advanceOrdering) {
      if (this.unavailableProducts["".concat(id)]) {
        return {
          isUnavailable: true,
          unAvailableMessage: ""
        };
      } else {
        return findMenuItemAvailibity({
          advanceOrdering: advanceOrdering,
          dayPartInfo: dayPartInfo,
          currentPickupTime: this._currentPickupTime
        });
      }
    }
  }, {
    key: "_decodeIsAdvanceOrderingProduct",
    value: function _decodeIsAdvanceOrderingProduct(isUnavailable, unAvailableMessage) {
      var _this$_appAttributes14, _this$_appAttributes15;

      return decodeIsAdvanceOrderingProduct(isUnavailable, unAvailableMessage, (_this$_appAttributes14 = this._appAttributes) === null || _this$_appAttributes14 === void 0 ? void 0 : (_this$_appAttributes15 = _this$_appAttributes14.configs) === null || _this$_appAttributes15 === void 0 ? void 0 : _this$_appAttributes15.isAdvanceOrderingAllowed);
    }
  }, {
    key: "decodeSubSubCategory",
    value: function decodeSubSubCategory(subSubCat) {
      var _subSubCat$menu,
          _this22 = this,
          _subSubCat$menu2;

      var decodedSubSubCatItems = subSubCat === null || subSubCat === void 0 ? void 0 : (_subSubCat$menu = subSubCat.menu) === null || _subSubCat$menu === void 0 ? void 0 : _subSubCat$menu.map(function (menu) {
        return _this22.decodeMenuItem(menu);
      });
      return {
        name: subSubCat.name,
        code: subSubCat.slug,
        slug: subSubCat.slug,
        itemCount: (subSubCat === null || subSubCat === void 0 ? void 0 : (_subSubCat$menu2 = subSubCat.menu) === null || _subSubCat$menu2 === void 0 ? void 0 : _subSubCat$menu2.length) || 0,
        items: this.filterItemsByOrderType(decodedSubSubCatItems) || [],
        // eslint-disable-next-line sonarjs/no-duplicate-string
        icon: "appetizers.svg"
      };
    }
  }, {
    key: "decodeSubCategory",
    value: function decodeSubCategory(subCat) {
      var _subCat$menu,
          _this23 = this,
          _subCat$menu2,
          _subCat$menucategorie; // console.log({ subCat });


      var decodedSubCatItems = subCat === null || subCat === void 0 ? void 0 : (_subCat$menu = subCat.menu) === null || _subCat$menu === void 0 ? void 0 : _subCat$menu.map(function (menu) {
        return _this23.decodeMenuItem(menu);
      });
      return {
        name: subCat.name,
        code: subCat.slug,
        slug: subCat.name.replace(" ", "-"),
        imageURL: subCat.imageURL,
        imageAltText: subCat.imageAltText,
        mobileBrowseImageURL: subCat.mobileBrowseImageURL,
        mobileBrowseImageAltText: subCat.mobileBrowseImageAltText,
        itemCount: (subCat === null || subCat === void 0 ? void 0 : (_subCat$menu2 = subCat.menu) === null || _subCat$menu2 === void 0 ? void 0 : _subCat$menu2.length) || 0,
        items: this.filterItemsByOrderType(decodedSubCatItems) || [],
        subSubCategories: subCat === null || subCat === void 0 ? void 0 : (_subCat$menucategorie = subCat.menucategories) === null || _subCat$menucategorie === void 0 ? void 0 : _subCat$menucategorie.map(function (subSubCat) {
          return _this23.decodeSubSubCategory(subSubCat);
        }),
        icon: "appetizers.svg",
        longDescription: subCat.longDescription
      };
    }
  }, {
    key: "decodeCategory",
    value: function decodeCategory(cat) {
      var _BrandRules3,
          _this$_appAttributes16,
          _cat$menu,
          _this24 = this,
          _cat$menu2,
          _cat$menucategories;

      var externalLinkUrl = (_BrandRules3 = new BrandRules((_this$_appAttributes16 = this._appAttributes) === null || _this$_appAttributes16 === void 0 ? void 0 : _this$_appAttributes16.currentConceptCode)) === null || _BrandRules3 === void 0 ? void 0 : _BrandRules3.externalLinkUrl(cat.slug);
      var decodedItems = cat === null || cat === void 0 ? void 0 : (_cat$menu = cat.menu) === null || _cat$menu === void 0 ? void 0 : _cat$menu.map(function (menu) {
        return _this24.decodeMenuItem(menu);
      });

      if (externalLinkUrl && (cat === null || cat === void 0 ? void 0 : cat.slug) === "happy-hour") {
        this.getHappyHourDescription();
      }

      return {
        name: cat.name,
        code: cat.slug,
        slug: cat.slug,
        imageURL: cat.imageURL,
        imageAltText: cat.imageAltText,
        mobileBrowseImageURL: cat.mobileBrowseImageURL,
        mobileBrowseImageAltText: cat.mobileBrowseImageAltText,
        itemCount: (cat === null || cat === void 0 ? void 0 : (_cat$menu2 = cat.menu) === null || _cat$menu2 === void 0 ? void 0 : _cat$menu2.length) || 0,
        longDescription: !externalLinkUrl && this.isShowCategoryDescription ? cat.longDescription : "",
        subCategories: (cat === null || cat === void 0 ? void 0 : (_cat$menucategories = cat.menucategories) === null || _cat$menucategories === void 0 ? void 0 : _cat$menucategories.map(function (subCat) {
          return _this24.decodeSubCategory(subCat);
        })) || [],
        items: this.filterItemsByOrderType(decodedItems) || [],
        icon: "appetizers.svg",
        externalLinkUrl: externalLinkUrl,
        isTarbonMenuCategory: cat.isTarbonMenuCategory
      };
    }
  }, {
    key: "setPdfMenuUrl",
    value: function setPdfMenuUrl(_pdfMenuUrl) {
      var _this25 = this;

      runInAction(function () {
        _this25._pdfMenuUrl = _pdfMenuUrl;
      });
    }
  }, {
    key: "getMenuListItems",
    value: function getMenuListItems(menuListData) {
      var _this26 = this;

      var items = [];
      menuListData === null || menuListData === void 0 ? void 0 : menuListData.forEach(function (_cat) {
        if (_cat !== null && _cat !== void 0 && _cat.items) items = [].concat(_toConsumableArray(items), _toConsumableArray(_cat === null || _cat === void 0 ? void 0 : _cat.items));
        if (_cat !== null && _cat !== void 0 && _cat.subCategories) items = [].concat(_toConsumableArray(items), _toConsumableArray(_this26.getMenuListItems(_cat.subCategories)));
        if (_cat !== null && _cat !== void 0 && _cat.subSubCategories) items = [].concat(_toConsumableArray(items), _toConsumableArray(_this26.getMenuListItems(_cat === null || _cat === void 0 ? void 0 : _cat.subSubCategories)));
      });
      return items;
    }
  }, {
    key: "checkDefaultCategoryExists",
    value: function checkDefaultCategoryExists(defaultCategory) {
      var _this$menuListData, _this$menuListData$ca;

      return (_this$menuListData = this.menuListData) === null || _this$menuListData === void 0 ? void 0 : (_this$menuListData$ca = _this$menuListData.categories) === null || _this$menuListData$ca === void 0 ? void 0 : _this$menuListData$ca.some(function (category) {
        return (category === null || category === void 0 ? void 0 : category.slug) === defaultCategory;
      });
    }
  }, {
    key: "getHappyHourDescription",
    value: function () {
      var _getHappyHourDescription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this27 = this;

        var restaurantHours, happyHourList, finalSlots, weekDays, happyHourDesc;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                restaurantHours = this._restaurantHourList;
                happyHourList = [];
                restaurantHours.forEach(function (day) {
                  var _day$hoursInfo;

                  var happyHourObj = day === null || day === void 0 ? void 0 : (_day$hoursInfo = day.hoursInfo) === null || _day$hoursInfo === void 0 ? void 0 : _day$hoursInfo.find(function (hour) {
                    return (hour === null || hour === void 0 ? void 0 : hour.hourCode) === "HH";
                  });

                  if (happyHourObj) {
                    //@ts-ignore TODO(LS): change dayOfWeek to startDayOfWeek once API updated
                    var startDayOfWeek = happyHourObj === null || happyHourObj === void 0 ? void 0 : happyHourObj.dayOfWeek;
                    var endDayOfWeek = happyHourObj === null || happyHourObj === void 0 ? void 0 : happyHourObj.endDayOfWeek;
                    var startTime = happyHourObj === null || happyHourObj === void 0 ? void 0 : happyHourObj.startTime;
                    var endTime = happyHourObj === null || happyHourObj === void 0 ? void 0 : happyHourObj.endTime;
                    happyHourList.push({
                      startDayOfWeek: startDayOfWeek,
                      endDayOfWeek: endDayOfWeek,
                      startTime: startTime,
                      endTime: endTime
                    });
                  }
                });
                finalSlots = Array.from(new Set(happyHourList.map(function (a) {
                  return a.startDayOfWeek;
                }))).map(function (startDayOfWeek) {
                  return happyHourList.find(function (a) {
                    return a.startDayOfWeek === startDayOfWeek;
                  });
                });
                finalSlots.sort(function compare(a, b) {
                  if ((a === null || a === void 0 ? void 0 : a.startDayOfWeek) < (b === null || b === void 0 ? void 0 : b.startDayOfWeek)) {
                    return -1;
                  }

                  if ((a === null || a === void 0 ? void 0 : a.startDayOfWeek) > (b === null || b === void 0 ? void 0 : b.startDayOfWeek)) {
                    return 1;
                  }

                  return 0;
                });
                weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                happyHourDesc = finalSlots.map(function (item) {
                  if (item.startDayOfWeek === item.endDayOfWeek) {
                    return "".concat(weekDays[item.startDayOfWeek - 1], " from ").concat(item.startTime, " - ").concat(item.endTime);
                  }

                  return "".concat(weekDays[item.startDayOfWeek - 1], " - ").concat(weekDays[item.endDayOfWeek - 1], " from ").concat(item.startTime, " to ").concat(item.endTime);
                });
                runInAction(function () {
                  _this27._happyHourDescription = happyHourDesc;
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getHappyHourDescription() {
        return _getHappyHourDescription.apply(this, arguments);
      }

      return getHappyHourDescription;
    }()
  }, {
    key: "checkTempSliderWarningOptions",
    value: function checkTempSliderWarningOptions(optionName) {
      var _BrandRules4, _this$_appAttributes17;

      var temperatureSelectionWarning = (_BrandRules4 = new BrandRules((_this$_appAttributes17 = this._appAttributes) === null || _this$_appAttributes17 === void 0 ? void 0 : _this$_appAttributes17.currentConceptCode)) === null || _BrandRules4 === void 0 ? void 0 : _BrandRules4.getTemperatureSelectionWarning(optionName);
      return temperatureSelectionWarning;
    }
  }, {
    key: "itemSelectedForAdding",
    get: function get() {
      return this._itemSelectedForAdding;
    }
  }, {
    key: "route",
    get: function get() {
      return this._route;
    }
  }, {
    key: "showMenuCategoryModal",
    get: function get() {
      return this._showMenuCategoryModal;
    },
    set: function set(val) {
      var _this28 = this;

      runInAction(function () {
        _this28._showMenuCategoryModal = val;
      });
    }
  }, {
    key: "isHeaderBackgroundImage",
    get: function get() {
      var _BrandRules5, _this$_appAttributes18;

      return (_BrandRules5 = new BrandRules((_this$_appAttributes18 = this._appAttributes) === null || _this$_appAttributes18 === void 0 ? void 0 : _this$_appAttributes18.currentConceptCode)) === null || _BrandRules5 === void 0 ? void 0 : _BrandRules5.isHeaderBackgroundImage();
    }
  }, {
    key: "isRecommendationAlreadyViewed",
    get: function get() {
      return this._isRecommendationAlreadyViewed;
    }
  }, {
    key: "isGlobalBannerMessageVisible",
    get: function get() {
      var _this$_sessionDetails4;

      return !!((_this$_sessionDetails4 = this._sessionDetails) !== null && _this$_sessionDetails4 !== void 0 && _this$_sessionDetails4.globalBannerMessage);
    }
  }, {
    key: "showQuickAddMenuCustomizationModal",
    get: function get() {
      return !!this._showQuickAddMenuCustomizationModal;
    }
  }, {
    key: "quickAddItem",
    get: function get() {
      return this._quickAddItem;
    }
  }, {
    key: "isLoggedIn",
    get: function get() {
      return !!this._isLoggedIn;
    }
  }, {
    key: "favorites",
    get: function get() {
      return this._favoritesData;
    }
  }, {
    key: "showRestStatusFlag",
    get: function get() {
      return this._showRestStatusFlag;
    },
    set: function set(value) {
      var _this29 = this;

      runInAction(function () {
        _this29._showRestStatusFlag = value;
      });
    }
  }, {
    key: "editingLocation",
    get: function get() {
      return this._editingLocation;
    },
    set: function set(value) {
      var _this30 = this;

      runInAction(function () {
        _this30._editingLocation = value;
      });
    }
  }, {
    key: "currentAddToCartLoadingItemID",
    get: function get() {
      return this._currentAddToCartLoadingItemID;
    }
  }, {
    key: "showCategoryHeroImages",
    get: function get() {
      var _this$_appAttributes19, _this$_appAttributes20;

      if (((_this$_appAttributes19 = this._appAttributes) === null || _this$_appAttributes19 === void 0 ? void 0 : (_this$_appAttributes20 = _this$_appAttributes19.configs) === null || _this$_appAttributes20 === void 0 ? void 0 : _this$_appAttributes20.displayCatHeroImage) === "true") {
        return true;
      }

      return false;
    }
  }, {
    key: "isGridView",
    get: function get() {
      var _this$_appAttributes21, _this$_appAttributes22, _this$_appAttributes23, _this$_appAttributes24, _this$_appAttributes25, _this$_appAttributes26;

      if (((_this$_appAttributes21 = this._appAttributes) === null || _this$_appAttributes21 === void 0 ? void 0 : (_this$_appAttributes22 = _this$_appAttributes21.configs) === null || _this$_appAttributes22 === void 0 ? void 0 : _this$_appAttributes22.isMenuImagesSupported) === undefined || ((_this$_appAttributes23 = this._appAttributes) === null || _this$_appAttributes23 === void 0 ? void 0 : (_this$_appAttributes24 = _this$_appAttributes23.configs) === null || _this$_appAttributes24 === void 0 ? void 0 : _this$_appAttributes24.isMenuImagesSupported) === null || ((_this$_appAttributes25 = this._appAttributes) === null || _this$_appAttributes25 === void 0 ? void 0 : (_this$_appAttributes26 = _this$_appAttributes25.configs) === null || _this$_appAttributes26 === void 0 ? void 0 : _this$_appAttributes26.isMenuImagesSupported) === "true") {
        return true;
      }

      return false;
    }
  }, {
    key: "heroMedias",
    get: function get() {
      var _this$_appAttributes27, _this$_appAttributes28;

      if ((_this$_appAttributes27 = this._appAttributes) !== null && _this$_appAttributes27 !== void 0 && _this$_appAttributes27.heroMedia && (_this$_appAttributes28 = this._appAttributes) !== null && _this$_appAttributes28 !== void 0 && _this$_appAttributes28.mobileHeroMedia) {
        var _this$_appAttributes29, _this$_appAttributes30;

        return {
          heroMedia: (_this$_appAttributes29 = this._appAttributes) === null || _this$_appAttributes29 === void 0 ? void 0 : _this$_appAttributes29.heroMedia,
          mobileHeroMedia: (_this$_appAttributes30 = this._appAttributes) === null || _this$_appAttributes30 === void 0 ? void 0 : _this$_appAttributes30.mobileHeroMedia
        };
      }

      return null;
    }
  }, {
    key: "categories",
    get: function get() {
      return this._categories;
    }
  }, {
    key: "menuListData",
    get: function get() {
      return {
        categories: this._categories
      };
    }
  }, {
    key: "menuFlatList",
    get: function get() {
      var _this$_menuDetail,
          _this31 = this;

      var rawCategories = (_this$_menuDetail = this._menuDetail) === null || _this$_menuDetail === void 0 ? void 0 : _this$_menuDetail.subCategories;

      if (rawCategories && rawCategories.length) {
        var flatListItems = [];
        rawCategories.forEach(function (rawCategory) {
          var category = _this31.decodeCategory(rawCategory);

          flatListItems.push({
            category: category
          }); // Start: Sub Categories

          var subCategories = category.subCategories;

          if (subCategories && subCategories.length) {
            subCategories.forEach(function (subCategory) {
              flatListItems.push({
                subCategory: subCategory
              }); // Start: Sub Sub Categories

              var subSubCategories = subCategory.subSubCategories;

              if (subSubCategories && subSubCategories.length) {
                subSubCategories.forEach(function (subSubCategoryItem) {
                  flatListItems.push({
                    subSubCategory: subSubCategoryItem
                  });
                  var subSubCategoryItems = subSubCategoryItem.items;

                  if (subSubCategoryItems && subSubCategoryItems.length) {
                    flatListItems.push({
                      items: subSubCategoryItems
                    });
                  }
                });
              } // End: Sub Sub Categories


              var subCategoryItems = subCategory.items;

              if (subCategoryItems && subCategoryItems.length) {
                flatListItems.push({
                  items: subCategoryItems
                });
              }
            });
          } // End: Sub Categories


          var categoryItems = category.items;

          if (categoryItems && categoryItems.length) {
            flatListItems.push({
              items: categoryItems
            });
          }
        });
        return flatListItems;
      } else {
        return [];
      }
    }
  }, {
    key: "orderType",
    get: function get() {
      var _this$_sessionDetails5, _this$_sessionDetails6;

      return this._orderTypeValue || ((_this$_sessionDetails5 = this._sessionDetails) === null || _this$_sessionDetails5 === void 0 ? void 0 : (_this$_sessionDetails6 = _this$_sessionDetails5.orderContext) === null || _this$_sessionDetails6 === void 0 ? void 0 : _this$_sessionDetails6.orderTypeValue);
    }
  }, {
    key: "isEmergencyShutOff",
    get: function get() {
      /*const nonDefaultMenu =
        this._sessionDetails.onlineTogoEnabled === true ||
        this._sessionDetails.onlineDeliveryEnabled === true;
      const defaultMenu =
        !this._resturantId &&
        this._appAttributes?.configs.enableDefaultMenu === "true";
      */
      //return !(nonDefaultMenu || defaultMenu);
      return false;
    }
  }, {
    key: "isTogoDeliveryOrder",
    get: function get() {
      return this.orderType === ORDER_TYPE.TOGO_DELIVERY;
    }
  }, {
    key: "unavailableProducts",
    get: function get() {
      var _this$_unavailableIte;

      return ((_this$_unavailableIte = this._unavailableItems) === null || _this$_unavailableIte === void 0 ? void 0 : _this$_unavailableIte.productsMap) || {};
    }
  }, {
    key: "isPriceHidden",
    get: function get() {
      return !this._resturantId && this._appAttributes.configs.enableDefaultMenu === "true" && this._appAttributes.configs.hidePricingForDefaultMenu === "true";
    }
  }, {
    key: "categoryRefs",
    get: function get() {
      return this._categoryRefs;
    }
  }, {
    key: "currentCategoryRefsAsArray",
    get: function get() {
      var _Object$entries,
          _this32 = this;

      return (_Object$entries = Object.entries(this._categoryRefs)) === null || _Object$entries === void 0 ? void 0 : _Object$entries.filter(function (section) {
        var _this32$menuListData, _this32$menuListData$;

        return (_this32$menuListData = _this32.menuListData) === null || _this32$menuListData === void 0 ? void 0 : (_this32$menuListData$ = _this32$menuListData.categories) === null || _this32$menuListData$ === void 0 ? void 0 : _this32$menuListData$.some(function (cat) {
          return cat.code === section[0];
        });
      });
    }
  }, {
    key: "nextCategoryCode",
    get: function get() {
      return this._nextCategoryCode;
    },
    set: function set(_nextCategoryCode) {
      var _this33 = this;

      runInAction(function () {
        _this33._nextCategoryCode = _nextCategoryCode;
      });
    }
  }, {
    key: "currentCategoryCode",
    get: function get() {
      return this._currentCategoryCode;
    },
    set: function set(_currentCategoryCode) {
      var _this34 = this;

      runInAction(function () {
        _this34._currentCategoryCode = _currentCategoryCode;
      });
    }
  }, {
    key: "frequentlyOrderedItems",
    get: function get() {
      var _this$_frequentlyOrde,
          _this$_frequentlyOrde2,
          _this35 = this;

      var menulist = this.menulistItems.flat().filter(Boolean).filter(function (_i) {
        return !_i.isUnavailable;
      });
      return this._frequentlyOrderedItems ? (_this$_frequentlyOrde = this._frequentlyOrderedItems) === null || _this$_frequentlyOrde === void 0 ? void 0 : (_this$_frequentlyOrde2 = _this$_frequentlyOrde.productList) === null || _this$_frequentlyOrde2 === void 0 ? void 0 : _this$_frequentlyOrde2.map(function (r) {
        return _this35.decodeFrequentlyOrderedItems(r, menulist);
      }).filter(Boolean) : [];
    } // Mock data for Reorder screen ends

  }, {
    key: "recommendations",
    get: function get() {
      var _this$_appAttributes31,
          _this$_appAttributes32,
          _this$_appAttributes33,
          _this$_recommendation2,
          _this36 = this;

      var threshold = isTrue((this === null || this === void 0 ? void 0 : this.route) === "menuListing", Number((_this$_appAttributes31 = this._appAttributes) === null || _this$_appAttributes31 === void 0 ? void 0 : _this$_appAttributes31.configs.menuBrowseSmartRecThreshold), Number((_this$_appAttributes32 = this._appAttributes) === null || _this$_appAttributes32 === void 0 ? void 0 : (_this$_appAttributes33 = _this$_appAttributes32.configs) === null || _this$_appAttributes33 === void 0 ? void 0 : _this$_appAttributes33.menuGridSmartRecThreshold));
      var menulist = this.menulistItems.flat().filter(Boolean).filter(function (_i) {
        return !_i.isUnavailable;
      });
      return this._recommendationsList ? (_this$_recommendation2 = this._recommendationsList.map(function (r) {
        return _this36.decodeRecommendations(r, menulist);
      }).filter(Boolean)) === null || _this$_recommendation2 === void 0 ? void 0 : _this$_recommendation2.slice(0, threshold) : [];
    }
  }, {
    key: "checkoutsmartrecommendations",
    get: function get() {
      var _this$_checkoutSmartR,
          _this37 = this,
          _this$_appAttributes34,
          _this$_appAttributes35;

      var menulist = this.menulistItems.flat().filter(Boolean).filter(function (_i) {
        return !_i.isUnavailable;
      });
      return this._checkoutSmartRecommendationsList ? (_this$_checkoutSmartR = this._checkoutSmartRecommendationsList.map(function (r) {
        return _this37.decodeRecommendations(r, menulist);
      }).filter(Boolean)) === null || _this$_checkoutSmartR === void 0 ? void 0 : _this$_checkoutSmartR.slice(0, Number((_this$_appAttributes34 = this._appAttributes) === null || _this$_appAttributes34 === void 0 ? void 0 : (_this$_appAttributes35 = _this$_appAttributes34.configs) === null || _this$_appAttributes35 === void 0 ? void 0 : _this$_appAttributes35.shoppingCartSmartRecThreshold)) : [];
    }
  }, {
    key: "isShowCategoryDescription",
    get: function get() {
      var _this$_appAttributes36, _this$_appAttributes37;

      return ((_this$_appAttributes36 = this._appAttributes) === null || _this$_appAttributes36 === void 0 ? void 0 : (_this$_appAttributes37 = _this$_appAttributes36.configs) === null || _this$_appAttributes37 === void 0 ? void 0 : _this$_appAttributes37.displaySubcategoryDescription) === "true" ? true : false;
    }
  }, {
    key: "isDefaultMenuSupported",
    get: function get() {
      var _this$_appAttributes38, _this$_appAttributes39;

      return ((_this$_appAttributes38 = this._appAttributes) === null || _this$_appAttributes38 === void 0 ? void 0 : (_this$_appAttributes39 = _this$_appAttributes38.configs) === null || _this$_appAttributes39 === void 0 ? void 0 : _this$_appAttributes39.enableDefaultMenu) === "true";
    }
  }, {
    key: "showCalorieDetailsInMenuList",
    get: function get() {
      var _this$_appAttributes40, _this$_appAttributes41, _this$_sessionDetails7, _this$_sessionDetails8;

      return ((_this$_appAttributes40 = this._appAttributes) === null || _this$_appAttributes40 === void 0 ? void 0 : (_this$_appAttributes41 = _this$_appAttributes40.configs) === null || _this$_appAttributes41 === void 0 ? void 0 : _this$_appAttributes41.hideCaloriesInMenuList) !== "true" && ((_this$_sessionDetails7 = this._sessionDetails) === null || _this$_sessionDetails7 === void 0 ? void 0 : (_this$_sessionDetails8 = _this$_sessionDetails7.orderContext) === null || _this$_sessionDetails8 === void 0 ? void 0 : _this$_sessionDetails8.showCalories);
    }
  }, {
    key: "maxQuantityThreshold",
    get: function get() {
      var _this$_sessionDetails9;

      return ((_this$_sessionDetails9 = this._sessionDetails) === null || _this$_sessionDetails9 === void 0 ? void 0 : _this$_sessionDetails9.maxQuantityThreshold) || 100;
    }
  }, {
    key: "PdfMenuURL",
    get: function get() {
      return this._pdfMenuUrl;
    }
  }, {
    key: "menulistItems",
    get: function get() {
      var _this$menuListData2;

      var items = this.getMenuListItems((_this$menuListData2 = this.menuListData) === null || _this$menuListData2 === void 0 ? void 0 : _this$menuListData2.categories);
      return items && Array.isArray(items) ? items.filter(Boolean) : [];
    }
  }, {
    key: "defaultCategoryCode",
    get: function get() {
      var _BrandRules6, _this$_appAttributes42, _BrandRules7, _this$_appAttributes43, _this$menuListData3, _this$menuListData3$c;

      var defaultCategory = (_BrandRules6 = new BrandRules((_this$_appAttributes42 = this._appAttributes) === null || _this$_appAttributes42 === void 0 ? void 0 : _this$_appAttributes42.currentConceptCode)) === null || _BrandRules6 === void 0 ? void 0 : _BrandRules6.getDefaultCategoryCode(this._lunchSlots, this._currentTime, this.orderType === ORDER_TYPE.ORDER_AHEAD);
      var shouldShowFirstCateByDefault = (_BrandRules7 = new BrandRules((_this$_appAttributes43 = this._appAttributes) === null || _this$_appAttributes43 === void 0 ? void 0 : _this$_appAttributes43.currentConceptCode)) === null || _BrandRules7 === void 0 ? void 0 : _BrandRules7.shouldShowFirstCategoryByDefault();

      if ((_this$menuListData3 = this.menuListData) !== null && _this$menuListData3 !== void 0 && (_this$menuListData3$c = _this$menuListData3.categories) !== null && _this$menuListData3$c !== void 0 && _this$menuListData3$c.length) {
        var _this$menuListData4, _this$menuListData4$c;

        var slug = (_this$menuListData4 = this.menuListData) === null || _this$menuListData4 === void 0 ? void 0 : (_this$menuListData4$c = _this$menuListData4.categories[0]) === null || _this$menuListData4$c === void 0 ? void 0 : _this$menuListData4$c.slug;
        var isDefaultCategoryPresent = this.checkDefaultCategoryExists(defaultCategory);

        if ((shouldShowFirstCateByDefault || !isDefaultCategoryPresent) && !!slug) {
          return slug;
        }
      }

      return defaultCategory;
    }
  }, {
    key: "enableMenuDetailsSmartRec",
    get: function get() {
      var _this$_appAttributes44, _this$_appAttributes45;

      return ((_this$_appAttributes44 = this._appAttributes) === null || _this$_appAttributes44 === void 0 ? void 0 : (_this$_appAttributes45 = _this$_appAttributes44.configs) === null || _this$_appAttributes45 === void 0 ? void 0 : _this$_appAttributes45.enableMenuDetailsSmartRec) === "true";
    }
  }, {
    key: "enableShoppingCartSmartRec",
    get: function get() {
      var _this$_appAttributes46, _this$_appAttributes47;

      return ((_this$_appAttributes46 = this._appAttributes) === null || _this$_appAttributes46 === void 0 ? void 0 : (_this$_appAttributes47 = _this$_appAttributes46.configs) === null || _this$_appAttributes47 === void 0 ? void 0 : _this$_appAttributes47.enableShoppingCartSmartRec) === "true";
    }
  }, {
    key: "enableMenuGridSmartRec",
    get: function get() {
      var _this$_appAttributes48, _this$_appAttributes49;

      return ((_this$_appAttributes48 = this._appAttributes) === null || _this$_appAttributes48 === void 0 ? void 0 : (_this$_appAttributes49 = _this$_appAttributes48.configs) === null || _this$_appAttributes49 === void 0 ? void 0 : _this$_appAttributes49.enableMenuGridSmartRec) === "true";
    }
  }, {
    key: "enableMenuItemsSmartRec",
    get: function get() {
      var _this$_appAttributes50, _this$_appAttributes51;

      return ((_this$_appAttributes50 = this._appAttributes) === null || _this$_appAttributes50 === void 0 ? void 0 : (_this$_appAttributes51 = _this$_appAttributes50.configs) === null || _this$_appAttributes51 === void 0 ? void 0 : _this$_appAttributes51.enableMenuItemsSmartRec) === "true";
    }
  }, {
    key: "hideCalorieOnMenuList",
    get: function get() {
      var _BrandRules8, _this$_appAttributes52;

      return (_BrandRules8 = new BrandRules((_this$_appAttributes52 = this._appAttributes) === null || _this$_appAttributes52 === void 0 ? void 0 : _this$_appAttributes52.currentConceptCode)) === null || _BrandRules8 === void 0 ? void 0 : _BrandRules8.getIfHideCaloriefDataOnMenuList();
    }
  }, {
    key: "doesSupportMenuListRecommendation",
    get: function get() {
      var _BrandRules9, _this$_appAttributes53;

      return (_BrandRules9 = new BrandRules((_this$_appAttributes53 = this._appAttributes) === null || _this$_appAttributes53 === void 0 ? void 0 : _this$_appAttributes53.currentConceptCode)) === null || _BrandRules9 === void 0 ? void 0 : _BrandRules9.doesSupportMenuListRecommendation();
    }
  }, {
    key: "shouldDisplayMenuRecommendationsTab",
    get: function get() {
      var _BrandRules10, _this$_appAttributes54;

      return (_BrandRules10 = new BrandRules((_this$_appAttributes54 = this._appAttributes) === null || _this$_appAttributes54 === void 0 ? void 0 : _this$_appAttributes54.currentConceptCode)) === null || _BrandRules10 === void 0 ? void 0 : _BrandRules10.shouldShowMenuRecommendationTab();
    }
  }, {
    key: "showCircularAddToCartButton",
    get: function get() {
      var _this$_appAttributes55, _this$_appAttributes56;

      return new BrandRules((_this$_appAttributes55 = this._appAttributes) === null || _this$_appAttributes55 === void 0 ? void 0 : (_this$_appAttributes56 = _this$_appAttributes55.concept) === null || _this$_appAttributes56 === void 0 ? void 0 : _this$_appAttributes56.conceptCode).showCircularAddToCartButton();
    }
  }, {
    key: "categoryGradientBg",
    get: function get() {
      var _this$_appAttributes57, _this$_appAttributes58;

      return new BrandRules((_this$_appAttributes57 = this._appAttributes) === null || _this$_appAttributes57 === void 0 ? void 0 : (_this$_appAttributes58 = _this$_appAttributes57.concept) === null || _this$_appAttributes58 === void 0 ? void 0 : _this$_appAttributes58.conceptCode).categoryGradientBg();
    }
  }, {
    key: "isImageDisplayed",
    get: function get() {
      var _this$_appAttributes59;

      return new BrandRules((_this$_appAttributes59 = this._appAttributes) === null || _this$_appAttributes59 === void 0 ? void 0 : _this$_appAttributes59.currentConceptCode).isImageDisplayed();
    }
  }, {
    key: "showBgCoverImage",
    get: function get() {
      var _this$_appAttributes60;

      return new BrandRules((_this$_appAttributes60 = this._appAttributes) === null || _this$_appAttributes60 === void 0 ? void 0 : _this$_appAttributes60.currentConceptCode).showBgCoverImage();
    }
  }, {
    key: "showPDFMenu",
    get: function get() {
      var _this$_appAttributes61;

      return new BrandRules((_this$_appAttributes61 = this._appAttributes) === null || _this$_appAttributes61 === void 0 ? void 0 : _this$_appAttributes61.currentConceptCode).showPDFMenu();
    }
  }, {
    key: "showPDFMenuDesktop",
    get: function get() {
      var _this$_appAttributes62, _this$_appAttributes63, _this$_appAttributes64, _this$_appAttributes65;

      if ((_this$_appAttributes62 = this._appAttributes) !== null && _this$_appAttributes62 !== void 0 && (_this$_appAttributes63 = _this$_appAttributes62.configs) !== null && _this$_appAttributes63 !== void 0 && _this$_appAttributes63.showPDFMenuDesktop && ((_this$_appAttributes64 = this._appAttributes) === null || _this$_appAttributes64 === void 0 ? void 0 : (_this$_appAttributes65 = _this$_appAttributes64.configs) === null || _this$_appAttributes65 === void 0 ? void 0 : _this$_appAttributes65.showPDFMenuDesktop) === "true") {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "reorderPageAddButtonType",
    get: function get() {
      var _this$_appAttributes66;

      return new BrandRules((_this$_appAttributes66 = this._appAttributes) === null || _this$_appAttributes66 === void 0 ? void 0 : _this$_appAttributes66.currentConceptCode).getReoderPageAddButtonType();
    }
  }, {
    key: "isDineinOrder",
    get: function get() {
      return this.orderType === ORDER_TYPE.ORDER_AHEAD;
    }
  }, {
    key: "happyHourDescription",
    get: function get() {
      return this._happyHourDescription.join("\n");
    }
  }, {
    key: "restaurantHourList",
    set: function set(list) {
      var _this38 = this;

      runInAction(function () {
        _this38._restaurantHourList = list;
      });
    }
  }, {
    key: "isMenuItemNameThreeLines",
    get: function get() {
      var _this$_appAttributes67;

      return new BrandRules((_this$_appAttributes67 = this._appAttributes) === null || _this$_appAttributes67 === void 0 ? void 0 : _this$_appAttributes67.currentConceptCode).doesSupportMenuItemNameWith3Lines();
    }
  }, {
    key: "tempSelectionMenuIdsMap",
    set: function set(_ref) {
      var _this39 = this;

      var key = _ref.key,
          value = _ref.value;
      runInAction(function () {
        _this39._tempSelectionMenuIdsMap.set(key, value);
      });
    }
  }, {
    key: "isDeliveryFlowEnabled",
    get: function get() {
      return (this === null || this === void 0 ? void 0 : this.orderType) === ORDER_TYPE.CATERING_DELIVERY;
    }
  }, {
    key: "searchRestaurantsPageSize",
    get: function get() {
      var _this$_appAttributes68, _this$_appAttributes69, _this$_appAttributes70, _BrandRules11, _this$_appAttributes71;

      return (// @ts-expect-error types
        +((_this$_appAttributes68 = this._appAttributes) === null || _this$_appAttributes68 === void 0 ? void 0 : (_this$_appAttributes69 = _this$_appAttributes68.configs) === null || _this$_appAttributes69 === void 0 ? void 0 : (_this$_appAttributes70 = _this$_appAttributes69.restaurant) === null || _this$_appAttributes70 === void 0 ? void 0 : _this$_appAttributes70.resultsPerPage) || ((_BrandRules11 = new BrandRules((_this$_appAttributes71 = this._appAttributes) === null || _this$_appAttributes71 === void 0 ? void 0 : _this$_appAttributes71.currentConceptCode)) === null || _BrandRules11 === void 0 ? void 0 : _BrandRules11.searchRestaurantsPageSize())
      );
    }
  }, {
    key: "showNutritionalInfo",
    get: function get() {
      var _BrandRules12, _this$_appAttributes72;

      return (_BrandRules12 = new BrandRules((_this$_appAttributes72 = this._appAttributes) === null || _this$_appAttributes72 === void 0 ? void 0 : _this$_appAttributes72.currentConceptCode)) === null || _BrandRules12 === void 0 ? void 0 : _BrandRules12.showNutritionalInfo();
    }
  }, {
    key: "mobileAppLocationListShowsInternationalLocations",
    get: function get() {
      var _this$_appAttributes73;

      return new BrandRules((_this$_appAttributes73 = this._appAttributes) === null || _this$_appAttributes73 === void 0 ? void 0 : _this$_appAttributes73.currentConceptCode).mobileAppLocationListShowsInternationalLocations();
    }
  }, {
    key: "bottomTabsContainReservations",
    get: function get() {
      var _this$_appAttributes74;

      return new BrandRules((_this$_appAttributes74 = this._appAttributes) === null || _this$_appAttributes74 === void 0 ? void 0 : _this$_appAttributes74.currentConceptCode).bottomTabsContainReservations();
    }
  }, {
    key: "mobileAppBottomTabsMenuStackLabel",
    get: function get() {
      var _this$_appAttributes75;

      return new BrandRules((_this$_appAttributes75 = this._appAttributes) === null || _this$_appAttributes75 === void 0 ? void 0 : _this$_appAttributes75.currentConceptCode).mobileAppBottomTabsMenuStackLabel();
    }
  }, {
    key: "isMenuListingAddCTARound",
    get: function get() {
      var _this$_appAttributes76;

      return new BrandRules((_this$_appAttributes76 = this._appAttributes) === null || _this$_appAttributes76 === void 0 ? void 0 : _this$_appAttributes76.currentConceptCode).isMenuListingAddCTARound();
    }
  }]);

  return MenuListModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_currentCategoryCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_nextCategoryCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_categoryRefs", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_menuDetail", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_actualPickupTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_unavailableItems", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_dayPartInfo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_favoritesData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_isListView", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_recommendationsList", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_checkoutSmartRecommendationsList", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_resturantId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_isLoggedIn", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_quickAddItem", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_showQuickAddMenuCustomizationModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_frequentlyOrderedItems", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_showCategoryHeroImages", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_currentPickupTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "_orderTypeValue", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "_route", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "menuListing";
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "_isRecommendationAlreadyViewed", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "_itemSelectedForAdding", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "_showRestStatusFlag", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "_editingLocation", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "_happyHourDescription", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "_restaurantHourList", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "_currentAddToCartLoadingItemID", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "_lunchSlots", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "_currentTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "_showMenuCategoryModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "_categories", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "_tempSelectionMenuIdsMap", [_dec, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return new Map();
  }
}), _applyDecoratedDescriptor(_class.prototype, "setItemSelectedForAdding", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setItemSelectedForAdding"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formatPrice", [action], Object.getOwnPropertyDescriptor(_class.prototype, "formatPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "itemSelectedForAdding", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "itemSelectedForAdding"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setRoute", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setRoute"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "route", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "route"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showMenuCategoryModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showMenuCategoryModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isHeaderBackgroundImage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isHeaderBackgroundImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isRecommendationAlreadyViewed", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isRecommendationAlreadyViewed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGlobalBannerMessageVisible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isGlobalBannerMessageVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setLunchSlotsAndCurrentTime", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setLunchSlotsAndCurrentTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showQuickAddMenuCustomizationModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showQuickAddMenuCustomizationModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "quickAddItem", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "quickAddItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUserLoggedInData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setUserLoggedInData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLoggedIn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoggedIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "favorites", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "favorites"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showRestStatusFlag", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showRestStatusFlag"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editingLocation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "editingLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCurrentAddToCartLoadingItemID", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCurrentAddToCartLoadingItemID"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentAddToCartLoadingItemID", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentAddToCartLoadingItemID"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCategoryHeroImages", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCategoryHeroImages"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGridView", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isGridView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAttributes", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "heroMedias", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "heroMedias"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "categories", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "categories"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "menuListData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "menuListData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setOrderTypeValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setOrderTypeValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEmergencyShutOff", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEmergencyShutOff"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isTogoDeliveryOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isTogoDeliveryOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unavailableProducts", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unavailableProducts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPriceHidden", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPriceHidden"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "categoryRefs", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "categoryRefs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentCategoryRefsAsArray", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentCategoryRefsAsArray"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextCategoryCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "nextCategoryCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentCategoryCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentCategoryCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "frequentlyOrderedItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "frequentlyOrderedItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recommendations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "recommendations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkoutsmartrecommendations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkoutsmartrecommendations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isShowCategoryDescription", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isShowCategoryDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDefaultMenuSupported", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDefaultMenuSupported"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCalorieDetailsInMenuList", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCalorieDetailsInMenuList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxQuantityThreshold", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxQuantityThreshold"), _class.prototype), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "_pdfMenuUrl", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "PdfMenuURL", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "PdfMenuURL"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "menulistItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "menulistItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultCategoryCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultCategoryCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enableMenuDetailsSmartRec", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "enableMenuDetailsSmartRec"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enableShoppingCartSmartRec", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "enableShoppingCartSmartRec"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enableMenuGridSmartRec", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "enableMenuGridSmartRec"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enableMenuItemsSmartRec", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "enableMenuItemsSmartRec"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideCalorieOnMenuList", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideCalorieOnMenuList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "doesSupportMenuListRecommendation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "doesSupportMenuListRecommendation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shouldDisplayMenuRecommendationsTab", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "shouldDisplayMenuRecommendationsTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCircularAddToCartButton", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCircularAddToCartButton"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "categoryGradientBg", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "categoryGradientBg"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isImageDisplayed", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isImageDisplayed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showBgCoverImage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showBgCoverImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPDFMenu", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showPDFMenu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPDFMenuDesktop", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showPDFMenuDesktop"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reorderPageAddButtonType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "reorderPageAddButtonType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDineinOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDineinOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "happyHourDescription", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "happyHourDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMenuItemNameThreeLines", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMenuItemNameThreeLines"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDeliveryFlowEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDeliveryFlowEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchRestaurantsPageSize", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchRestaurantsPageSize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showNutritionalInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showNutritionalInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mobileAppLocationListShowsInternationalLocations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mobileAppLocationListShowsInternationalLocations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "bottomTabsContainReservations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "bottomTabsContainReservations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mobileAppBottomTabsMenuStackLabel", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mobileAppBottomTabsMenuStackLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMenuListingAddCTARound", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMenuListingAddCTARound"), _class.prototype)), _class));
export { MenuListModel as default };